import { render, staticRenderFns } from "./PanelInputBaseRadio.vue?vue&type=template&id=59560683&scoped=true&"
import script from "./PanelInputBaseRadio.vue?vue&type=script&lang=js&"
export * from "./PanelInputBaseRadio.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputBaseRadio.vue?vue&type=style&index=0&id=59560683&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59560683",
  null
  
)

export default component.exports